import React, { Component, Fragment } from "react";

export default class SelectCampo extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            linhaAtuacao: [
                "Consultoria em Tecnologia",
                "Consultoria em Processos Produtivos",
                "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",

                "Metrologia",
                "Calibração",
                "Ensaios",

                "Pesquisa, Desenvolvimento e Inovação",
                "Pesquisa, Desenvolvimento e Inovação de Produto",
                "Pesquisa, Desenvolvimento e Inovação de Processo",

                "Serviços Complementares",
                "Consultoria em Gestão Empresarial",

                "Serviços Técnicos Especializados",
                "Serviços Operacionais"
            ],
            unidades: [
                "DR",
                // "IST SENAI em Tecnologia em Automação Industrial",
                "IST SENAI em Tecnologia em Eficiência Operacional",
                "IST SENAI em Tecnologia Têxtil e Confecção"
            ],
            tipos: [
                "metasrealizados",
                "metas",
                "realizados"
            ],
            campos: [
                "horasTecnicas",
                "numeroAtendimento",
                "calibracoes",
                "ensaios",
                "relatoriosELaudos",
                // "receita",
                // "despesa",
            ],
            visao: [
                "mensal",
                "acumulado"
            ]
        }
    }

    render() {
        let { campo } = this.props;
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label className="text-capitalize">{campo || "modalidade"}: </label>
                            <select name="select" onChange={this.props.select} className="form-control" id={this.props.idComponente || "selectModalidade"}>
                                {this.state[campo || "linhaAtuacao"].map(modalidade => {
                                    return(
                                        <option value={modalidade}>{modalidade}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}